import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/view/home'
import NewsList from '@/view/NewsList'
import NewsContent from '@/view/NewsContent'

Vue.use(Router)
// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    }
    ,
    {
      path: '/news/:id',
      name: 'News',
      component: NewsList
    },
    {
      path: '/content/:id',
      name: 'Content',
      component: NewsContent
    }
  ],
  // 以下用于路由跳转 页面保持在顶部
  mode: 'hash',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js